import React from "react";
import ShippingGrid from "../components/Shipping/ShippingGrid";

interface Props {
  Title: string;
}

interface State {}

class Shipping extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  componentDidMount(): void {}

  render() {
    return (
      <div className="wrapper">
        <div className="section latest-offers">
          <div className="container">
            <h3 className="section-title">{this.props.Title}</h3>
            <hr />
            <ShippingGrid
              key={"ShippingGrid"}
              Title={"Shipping Values"}
              MaxRows={100}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Shipping;
